export default __webpack_public_path__ + "static/media/github.c503e7b7.svg";